import { createStore } from "vuex";
import VuexPersistence from "vuex-persist";

export default createStore({
  state: {
    EmailID: "",
    getIssueDetails: {},
    getPreviousRoute: "",
    currentUserDetails: {},
    orgEditObject: {},
  },
  getters: {
    get_user_email: (state) => {
      return state.EmailID;
    },
    get_issue_details: (state) => {
      return state.getIssueDetails;
    },
    get_previous_route: (state) => {
      return state.getPreviousRoute;
    },
    get_current_user_details: (state) => {
      return state.currentUserDetails;
    },
    get_org_edit_object: (state) => {
      return state.orgEditObject;
    },
  },
  mutations: {
    SET_USEREMAIL(state, username) {
      state.EmailID = username;
    },
    SET_ISSUE_DETAILS(state, getIssueDetails) {
      state.getIssueDetails = getIssueDetails;
    },
    SET_PREVIOUS_ROUTE(state, route) {
      state.getPreviousRoute = route;
    },
    SET_CURRENTUSER_DETAILS(state, user) {
      state.currentUserDetails = user;
    },
    SET_ORG_EDIT_OBJECT(state, orgObject) {
      state.orgEditObject = orgObject;
    },
  },
  actions: {},
  modules: {},
  plugins: [new VuexPersistence().plugin],
});
